import { render, staticRenderFns } from "./full-screen-dialog.vue?vue&type=template&id=45bc8818&scoped=true&"
import script from "./full-screen-dialog.vue?vue&type=script&lang=js&"
export * from "./full-screen-dialog.vue?vue&type=script&lang=js&"
import style0 from "./full-screen-dialog.vue?vue&type=style&index=0&id=45bc8818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc8818",
  null
  
)

export default component.exports